import BaseTooltip from '@paladise/ui/components/BaseTooltip'
import { Button } from '@paladise/ui/components/ui/button'
import React from 'react'

interface Prop {
  text: string
}

const subscribeMedia = (listener: () => void) => {
  window.matchMedia('(hover: hover)').addEventListener('change', listener)
  return () => {
    window.matchMedia('(hover: hover)').removeEventListener('change', listener)
  }
}
const snapshot = () => {
  return window.matchMedia('(hover: hover)').matches
}
const serverSnapshot = () => {
  return false
}

function InfoTooltip({ text }: Prop) {
  const isHover = React.useSyncExternalStore(
    subscribeMedia,
    snapshot,
    serverSnapshot,
  )
  return (
    <BaseTooltip
      isHover={isHover}
      trigger={
        <Button
          type="button"
          variant="text"
          className="text-label-l2 ml-1 flex size-[16px] items-center justify-center p-0"
        >
          <span className="i-ps-info_s size-[16px] shrink-0" />
        </Button>
      }
    >
      <div className="text-caption max-w-[400px] px-3 py-2">{text}</div>
    </BaseTooltip>
  )
}

export default InfoTooltip
